//Import Mixpanel SDK
import {of} from 'rxjs';
import {filter,map,mergeMap,catchError,tap} from 'rxjs/operators';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import mixpanel from 'mixpanel-browser';

import config from '../../config/config';
import * as analytics from '../reducers/analytics';
import * as auth from '../reducers/auth';

const whitelistedActions = {
  [analytics.track.type]: {
    parser: action => omit(action?.payload || {}, 'eventName') || {},
  },
  [auth.logout.type]: {
    parser: action => ({}),
  },
};

// Initialize mixpanel if a public Mixpanel token is present
if (config().mixpanelToken) {
  mixpanel.init(config().mixpanelToken, {
    debug: false,
    track_pageview: 'full-url',
    persistence: 'localStorage',
  });
  // console.log('Mixpanel initialized');
}

const trackAction = action => {
  if (!config().mixpanelToken) return;
  if (!whitelistedActions?.[action.type]) return;
  const parser = whitelistedActions?.[action.type]?.parser || (() => ({}));
  const eventName = action?.payload?.eventName || action.type;
  // console.log('mixpanel.track', eventName, action, parser(action));
  mixpanel.track(eventName, parser(action));
};

export const identifyUser = (action$, state$, _auth = auth, _analytics = analytics) => {
  return action$.pipe(
    filter(() => !!config().mixpanelToken),
    filter(a => a.type === _auth.setCredentials.type),
    map(a => {
      if (a?.payload?.user?.id) mixpanel.identify(
        a?.payload?.user?.id,
        pick(a?.payload?.user || {}, ['is_provider', 'is_patient'])
      );
      return null;
    }),
    mergeMap(() => of()),
    catchError(() => of()),
  );
};

export const trackPageViews = (action$, state$, _analytics = analytics) => {
  return action$.pipe(
    filter(() => !!config().mixpanelToken),
    filter(a => a.type === _analytics.pageView.type),
    map(a => {
      mixpanel.track('Page View', a.payload);
      return null;
    }),
    mergeMap(() => of()),
    catchError(() => of()),
  );
};

export const shipEvents = (
  action$,
  state$,
  _trackAction = trackAction,
) => {
  return action$.pipe(
    filter(action => !!whitelistedActions?.[action.type]),
    tap(_trackAction),
    mergeMap(() => of()),
    catchError(() => of()),
  );
};
